import {CDFGqlModel} from "./cdf.gql-model";
import {AssetReconciliationResultItem} from "../asset-reconciliation/asset-reconciliation.model";
import {CdfImportService} from "./cdf-import.service";
import {toggleLoading} from "../misc/loading.decorator";
import {handleErrors} from "../misc/handle-errors.decorator";
import {createEvent} from "../misc/event.polyfill";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";

@Component({
  selector: "cdf-import",
  templateUrl: "./cdf-import.template.pug",
})
@exposeComponentInDebugMode()
export class CdfImportComponent implements OnChanges {
  cdf: CDFGqlModel = new CDFGqlModel({});
  assetReconciliationResult: AssetReconciliationResultItem[] = [];
  totalAssetsCount: number = 0;
  futureFleetAssetCount: number = 0;
  unconfiguredAssetsCount: number = 0;
  unconfiguredAccessoriesCount: number = 0;
  removeAssets: boolean = true;
  loading: boolean = false;

  assetReconciliationVisible: boolean = false;
  finalizeVisible: boolean = false;
  successful: boolean = false;
  isMigrationActive: boolean = false;

  /**
   * Error used by handleErrors()
   * Don't remove these
   */
  get error(): Error {
    return undefined;
  }

  set error(error: Error) {
    const event = createEvent("error");
    event["error"] = error;
    this.errorEmitter.emit(event);
  }

  @Input("projectId")
  projectId: string;

  @Input("siteId")
  siteId: string;

  @Output("error")
  errorEmitter: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(
    private cdfImportService: CdfImportService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnChanges() {
    this.loadDealData();
  }

  updateAssetCounts() {
    this.totalAssetsCount = this.cdf.assets.length;
    this.futureFleetAssetCount = this.cdf.assets.filter(asset => asset.dispositionInfo.isFutureFleet).length;

    this.finalizeVisible = this.futureFleetAssetCount > 0 &&
      this.unconfiguredAssetsCount === 0 &&
      this.unconfiguredAccessoriesCount === 0;

    this.assetReconciliationVisible = this.totalAssetsCount > 0;

    this.changeDetectorRef.detectChanges();
  }

  assetReconciliationChanged(event) {
    if (!event["items"]) return;

    this.assetReconciliationResult = event["items"] as AssetReconciliationResultItem[];
    this.unconfiguredAssetsCount = +event["unconfiguredAssets"];
    this.unconfiguredAccessoriesCount = +event["unconfiguredAccessories"];

    this.updateAssetCounts();
  }

  @toggleLoading()
  @handleErrors()
  async loadDealData() {
    if (!this.projectId) return;

    this.cdf = new CDFGqlModel({});

    this.assetReconciliationVisible = false;
    this.finalizeVisible = false;

    if (!this.projectId) return;

    const cdf = await this.cdfImportService.getCdf(this.projectId, this.siteId);
    this.isMigrationActive = cdf.isMigrationActive;

    if (!cdf.assets.length) {
      throw new Error("No acceptable devices were found.");
    }

    this.cdf = cdf;

    this.updateAssetCounts();
  }

  @toggleLoading()
  @handleErrors()
  async importDeal() {
    await this.cdfImportService.importCdf(this.cdf, this.projectId, this.removeAssets);

    this.successful = true;
  }
}
